import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class ToastService {
    constructor(private snackbar: MatSnackBar, private translate: TranslateService) { }


    showError(message: string, closeText: string = 'commons.snackbar-close'): MatSnackBarRef<TextOnlySnackBar> {
        return this.snackbar.open(this.translate.instant(message),
            this.translate.instant(closeText),
            {duration: 5000, panelClass: 'error-snackbar'});
    }

    showToast(message: string, closeText: string = 'commons.snackbar-close'): MatSnackBarRef<TextOnlySnackBar> {
        return this.snackbar.open(this.translate.instant(message),
            this.translate.instant(closeText),
            {duration: 5000});
    }
}
